import { render, staticRenderFns } from "./buyer-seller-form.vue?vue&type=template&id=06e0e7f4&"
import script from "./buyer-seller-form.vue?vue&type=script&lang=js&"
export * from "./buyer-seller-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports